import React, { Component } from 'react';
import { CardElement, injectStripe } from 'react-stripe-elements';
import { Button, Alert } from '@surfline/quiver-react';
import { PaymentRequestGift } from '../../containers';

class GiftPaymentForm extends Component {
  constructor(props) {
    super(props);
    this.submitPayment = this.submitPayment.bind(this);
  }
  componentDidMount() {
    this.props.viewedGiftPurchase({ step: 2 });
  }

  async submitPayment(walletToken = null) {
    const {
      stripe,
      savedGiftData,
      purchase
    } = this.props;

    let token = walletToken;
    if (!walletToken) {
      const { token: cardToken = null } = await stripe.createToken({ type: 'card' });
      token = cardToken;
    }
    const { id: source } = token || {};
    const giftCard = {
      ...savedGiftData,
      source
    };
    purchase(giftCard);
  }
  render() {
    const { submitting, error, selectedProduct } = this.props;
    return (
      <div className="gift-payment-form-container">
        <span>PAYMENT DETAILS</span>
        {error ? (
          <Alert type="error" style={{ marginBottom: '5px', textAlign: 'center' }} >
            {error}
          </Alert>
        ) : null}
        <CardElement disabled={submitting} />
        <Button loading={submitting} onClick={() => this.submitPayment()}>PURCHASE GIFT CARD</Button>
        <PaymentRequestGift paymentHandler={this.submitPayment} selectedProduct={selectedProduct} />
      </div>
    );
  }
}

export default injectStripe(GiftPaymentForm);
